import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function ArticulosCreateSolo() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  // const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  // const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CATALOGO_PROCESOS = process.env.REACT_APP_URL_CATALOGO_PROCESOS;
  // const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  // const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_DEPARTAMENTOS = process.env.REACT_APP_URL_DEPARTAMENTOS;
  // const URL_SUBDEPARTAMENTOS = process.env.REACT_APP_URL_SUBDEPARTAMENTOS;
  // const URL_CLASES = process.env.REACT_APP_URL_CLASES;
  // const URL_SUBCLASES = process.env.REACT_APP_URL_SUBCLASES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");
  const [fecha, setFecha] = useState(hoy);

  const [articulosGuardado, setArticulosGuardado] = useState([]);
  const [codigo, setCodigo] = useState("");
  const [pedido, setPedido] = useState("NA");
  const [codigoCliente, setCodigoCliente] = useState("NA");
  const [nombre, setNombre] = useState("");
  const [descripcion, setDescripcion] = useState("NA");
  const [codigoSAT, setCodigoSAT] = useState("NA");
  const [precio, setPrecio] = useState("NA");
  const [observaciones, setObservaciones] = useState("NA");
  // const [marcas, setMarcas] = useState([]);
  // const [colecciones, setColecciones] = useState([]);
  // const [selectedMarca, setSelectedMarca] = useState("");
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [catalogoProcesos, setCatalogoProcesos] = useState([]);

  // const [colaboradores, setColaboradores] = useState([]);
  // const [selectedVendedor, setSelectedVendedor] = useState("");

  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  // const [clientes, setClientes] = useState([]);
  // const [selectedCliente, setSelectedCliente] = useState("");

  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  // const [subDepartamentos, setSubDepartamentos] = useState([]);
  // const [selectedSubDepartamento, setSelectedSubDepartamento] = useState("");
  // const [clases, setClases] = useState([]);
  // const [selectedClase, setSelectedClase] = useState("");
  // const [subClases, setSubClases] = useState([]);
  // const [selectedSubClase, setSelectedSubClase] = useState("");
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");

  const [modalColores, setModalColores] = useState(false);
  const toggleColores = () => setModalColores(!modalColores);
  const [arrayColores, setArrayColores] = useState([]);

  const [modalTallas, setModalTallas] = useState(false);
  const toggleTallas = () => setModalTallas(!modalTallas);
  const [arrayTallas, setArrayTallas] = useState([]);

  const [modalProcesos, setModalProcesos] = useState(false);
  const toggleProcesos = () => setModalProcesos(!modalProcesos);
  const [arrayProcesos, setArrayProcesos] = useState([
    "6363fb596cdd150aab0461cd",
  ]);

  const [vista, setVista] = useState("Articulo");
  const [validaBoton, setValidaBoton] = useState(true);

  const [dataArtId, setDataArtId] = useState("");

  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);

  const [arrayProporcion, setArrayProporcion] = useState([]);
  const [arrayTotalColor, setArrayTotalColor] = useState([]);
  const [totalProporcion, setTotalProporcion] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [precioEtiqueta, setPrecioEtiqueta] = useState(0);

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [telas, setTelas] = useState([]);
  const [explosion, setExplosion] = useState([]);
  const [explosionHab, setExplosionHab] = useState([]);

  const [inputFieldsTela, setInputFieldsTela] = useState([
    {
      id: uuidv4(),
      idTela: "",
      idColor: "",
      cantidad: 0,
      cantidadPrenda: 0,
      observaciones: "NA",
    },
  ]);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      idColor: "",
      colorNombre: "",
      idTalla: "",
      tallaNombre: "",
      cantidad: 0,
      totalColor: 0,
    },
  ]);

  useEffect(() => {
    axios
      .get(URL_TELAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTelas = res.data;
        setTelas(allTelas);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_MARCAS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allMarcas = res.data;
    //     setMarcas(allMarcas);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    // axios
    //   .get(URL_COLECCIONES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColecciones = res.data;
    //     setColecciones(allColecciones);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_CATALOGO_PROCESOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCatalogoProcesos = res.data;
        setCatalogoProcesos(allCatalogoProcesos);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_COLABORADORES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allColaboradores = res.data;
    //     setColaboradores(allColaboradores);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_COMPRADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allCompradores = res.data;
        setCompradores(allCompradores);
      })
      .catch((err) => {
        console.log(err);
      });
    // axios
    //   .get(URL_CLIENTES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((res) => {
    //     const allClientes = res.data;
    //     setClientes(allClientes);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_DEPARTAMENTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allDep = response.data;
        setDepartamentos(allDep);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    // axios
    //   .get(URL_SUBDEPARTAMENTOS, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allSubDep = response.data;
    //     setSubDepartamentos(allSubDep);
    //     //
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    // axios
    //   .get(URL_CLASES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allClase = response.data;
    //     setClases(allClase);
    //     //
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    // axios
    //   .get(URL_SUBCLASES, {
    //     headers: {
    //       Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    //     },
    //   })
    //   .then((response) => {
    //     let allSubClase = response.data;
    //     setSubClases(allSubClase);
    //     //
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresa = response.data;
        setEmpresas(allEmpresa);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  function coloresSeleccionados(checked, idColor) {
    if (checked) {
      arrayColores.push(idColor);
    } else {
      const index = arrayColores.indexOf(idColor);
      if (index > -1) {
        arrayColores.splice(index, 1);
      }
    }
  }

  function tallasSeleccionados(checked, idColor) {
    if (checked) {
      arrayTallas.push(idColor);
    } else {
      const index = arrayTallas.indexOf(idColor);
      if (index > -1) {
        arrayTallas.splice(index, 1);
      }
    }
  }

  function procesosSeleccionados(checked, idColor) {
    if (checked) {
      arrayProcesos.push(idColor);
    } else {
      const index = arrayProcesos.indexOf(idColor);
      if (index > -1) {
        arrayProcesos.splice(index, 1);
      }
    }
  }

  const saveArticulos = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    try {
      let tempFoto = "No";
      if (file != null) {
        tempFoto = "Si";
      }
      await axios
        .post(
          URL_ARTICULOS,
          {
            fecha,
            descripcion,
            compradores: selectedComprador,
            // colaboradores: selectedVendedor,
            marcas: "65d8bdeb86de65fdd6715955",
            // colecciones: selectedColeccion,
            colores: arrayColores,
            tallas: arrayTallas,
            catalogoProcesos: arrayProcesos.filter((item, index) => {
              return arrayProcesos.indexOf(item) === index;
            }),
            patronista: "6776c78fb5a2d1c9c76c4fc2",
            muestrista: "6776c78fb5a2d1c9c76c4fc2",
            ploter: "6776c78fb5a2d1c9c76c4fc2",
            // clientes: selectedCliente,
            pedido,
            codigo,
            codigoCliente,
            departamentos: selectedDepartamento,
            subDepartamentos: "6578b80b26a9245bd3ddc6de",
            // clases: selectedClase,
            // subClases: selectedSubClase,
            fotoArticulo: tempFoto,
            costo: 0,
            precio,
            // catalogoProcesos: "6363fb596cdd150aab0461cd",
            codigoSAT,
            codigoUnidad: "H87",
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )

        .then((data) => {
          if (file != null) {
            const formData = new FormData();
            formData.append("file", file);
            formData.append("articulo", data.data._id);

            axios.post(URL_FILEPOST, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            });
          }

          axios
            .get(`${URL_ARTICULOS}/${data.data._id}`, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((res) => {
              const allArticulosGuardado = [res.data];
              setArticulosGuardado(allArticulosGuardado);
              setDataArtId(res.data._id);
              // setVista("Pedido");

              Swal.fire(
                "Good job!",
                `Creado con exito, Pedido ${data.data.idPedido}`,
                `success`
              );
              setTimeout(() => {
                window.location.reload();
              }, 2000);
          

              const newInputFields2 = [];
              allArticulosGuardado[0].colores.map((a) => {
                allArticulosGuardado[0].tallas.map((b) => {
                  newInputFields2.push({
                    id: uuidv4(),
                    idColor: a._id,
                    colorNombre: a.name,
                    idTalla: b._id,
                    tallaNombre: b.name,
                    cantidad: 0,
                  });
                });
              });

              setInputFields(newInputFields2);

              const newInputFields3 = [];
              allArticulosGuardado[0].tallas.map((b) => {
                newInputFields3.push({
                  id: uuidv4(),
                  idTalla: b._id,
                  tallaNombre: b.name,
                  proporcion: 0,
                });
              });

              setArrayProporcion(newInputFields3);

              const newInputFields4 = [];
              allArticulosGuardado[0].colores.map((b) => {
                newInputFields4.push({
                  id: uuidv4(),
                  idColor: b._id,
                  colorNombre: b.name,
                  totalColor: 0,
                });
              });

              setArrayTotalColor(newInputFields4);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };


  return (
    <>
      <Header />
      <br />
      <br />
      {user.articulos_create ? (
        <div className="card container col-11">
          <h3 align="center">Nuevo Articulo</h3>
            <>
              <Form onSubmit={saveArticulos}>
                <Row>
                  {/* <Col md={3}>
                    <Label>Cliente</Label>
                    <Input
                      type="select"
                      value={selectedCliente}
                      onChange={(e) => {
                        setSelectedCliente(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {clientes
                        .sort((a, b) =>
                          a.nombre_comercial > b.nombre_comercial ? 1 : -1
                        )
                        .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre_comercial}</option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Fecha Cita</Label>
                    <Input
                      type="date"
                      value={fecha}
                      onChange={(e) => {
                        setFecha(e.target.value);
                      }}
                    />
                  </Col> */}
                  <Col md={3}>
                    <Label>Modelo Provisional</Label>
                    <Input
                      type="text"
                      placeholder="Codigo"
                      value={codigo}
                      required
                      onChange={(e) => {
                        setCodigo(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Departamento</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {departamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Sub Departamento</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedSubDepartamento}
                      required
                      onChange={(e) => {
                        setSelectedSubDepartamento(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {subDepartamentos
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Clase</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedClase}
                      required
                      onChange={(e) => {
                        setSelectedClase(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {clases
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}

                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Etiqueta</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedSubClase}
                      required
                      onChange={(e) => {
                        setSelectedSubClase(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {subClases
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Label>Descripcion</Label>
                    <Input
                      type="text"
                      placeholder="Descripcion"
                      value={descripcion}
                      required
                      onChange={(e) => {
                        setDescripcion(e.target.value);
                      }}
                    />
                  </Col>
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Marca</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedMarca}
                      required
                      onChange={(e) => {
                        setSelectedMarca(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {marcas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                      </Col> */}
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Coleccion</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedColeccion}
                      required
                      onChange={(e) => {
                        setSelectedColeccion(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {colecciones
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label className="mr-sm-2">Vendedor</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedVendedor}
                      required
                      onChange={(e) => {
                        setSelectedVendedor(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {colaboradores
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.nombre} {a.apellido}
                            </option>
                          );
                        })}
                    </Input>
                  </Col> */}
                  <Col md={3}>
                    <Label className="mr-sm-2">Comprador</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedComprador}
                      required
                      onChange={(e) => {
                        setSelectedComprador(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {compradores
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <Label>Pedido Cliente</Label>
                    <Input
                      type="text"
                      placeholder="Pedido"
                      value={pedido}
                      required
                      onChange={(e) => {
                        setPedido(e.target.value);
                      }}
                    />
                  </Col>

                  <Col md={3}>
                    <Label>Modelo Oficial</Label>
                    <Input
                      type="text"
                      placeholder="CodigoCliente"
                      value={codigoCliente}
                      required
                      onChange={(e) => {
                        setCodigoCliente(e.target.value);
                      }}
                    />
                  </Col>
                  <Col md={3}>
                    <Label>CodigoSAT</Label>
                                    <Input
                                      type="select"
                                      placeholder="CodigoSAT"
                                      value={codigoSAT}
                                      required
                                      onChange={(e) => {
                                        setCodigoSAT(e.target.value);
                                      }}
                                    >
                                      <option value="">Selecciona</option>
                                      <option value="53101604">53101604 Blusas Mujer</option>
                                      <option value="53102002">
                                        53102002 Vestidos, Faldas, Jumper
                                      </option>
                                      <option value="53101504">53101504 Pantalones Mujer</option>
                                      <option value="53101804">53101804 Chamarras Mujer</option>
                                      <option value="53101704">53101704 Sweater Mujer</option>
                                      <option value="53103100">53103100 Chalecos</option>
                                      <option value="53102800">53102800 Trajes de Baño</option>
                                      <option value="53101602">53101602 Camisas Hombre</option>
                                      <option value="53101502">53101502 Pantalon Hombre</option>
                                      <option value="52121500">52121500 Cobija</option>
                                      <option value="52121509">52121509 Sabanas</option>
                                      <option value="53102606">53102606 Batas de Baño</option>
                                      <option value="52121701">52121701 Toallas de Baño</option>
                                      <option value="24122003">24122003 Botellas de cristal</option>
                                      <option value="11162000">11162000 Rayon Chalis</option>
                                      <option value="56141602">56141602 Vasos</option>
                                      <option value="52152104">52152104 Copas</option>
                                    </Input>
                  </Col>
                  <Col md={3}>
                    <Label>Precio</Label>
                    <Input
                      type="number"
                      placeholder="Precio"
                      value={precio}
                      required
                      onChange={(e) => {
                        setPrecio(e.target.value);
                      }}
                    />
                  </Col>
                  {/* <Col md={3}>
                    <Label className="mr-sm-2">Descuento</Label>
                    <Input
                      // bsSize="sm"
                      name="descuento"
                      type="number"
                      placeholder="Descuento"
                      value={descuento}
                      required
                      onChange={(e) => {
                        setDescuento(e.target.value);
                      }}
                    />
                  </Col> */}

                  {/* <Col md={3}>
                    <Label>Observaciones Diseño</Label>
                    <Input
                      type="textarea"
                      placeholder="Observaciones"
                      value={observaciones}
                      required
                      onChange={(e) => {
                        setObservaciones(e.target.value);
                      }}
                    />
                  </Col> */}
                </Row>

                <Row>
                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Colores
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Colores"
                      onClick={(e) => toggleColores()}
                    >
                      <i class="fas fa-palette fa-2x "></i>
                    </Button>
                  </Col>

                  <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Tallas
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Tallas"
                      onClick={(e) => toggleTallas()}
                    >
                      <i class="fas fa-ruler-horizontal fa-2x "></i>
                    </Button>
                  </Col>

                  {/* <Col md={2}>
                    <Label for="exampleEmail" className="mr-sm-2">
                      Agregar Procesos
                    </Label>
                    <br />
                    <Button
                      color="success"
                      id="Procesos"
                      onClick={(e) => toggleProcesos()}
                    >
                      <i class="fas fa-tshirt fa-2x "></i>
                    </Button>
                  </Col> */}
                  <Col md={4}>
                    <Label>Foto</Label>
                    <Input
                      type="file"
                      onChange={(e) => {
                        setFile(e.target.files[0]);
                      }}
                    />
                  </Col>
                </Row>
                <br />
                {validaBoton ? (
                  <Button type="submit" className="btn btn-success">
                    Guardar
                  </Button>
                ) : (
                  <Button type="submit" className="btn btn-success" disabled>
                    Guardar
                  </Button>
                )}
                <Button
                  href="/ListadoArticulos"
                  className="btn btn-danger"
                  id="botonListado"
                >
                  Regresar
                </Button>
              </Form>
            </>

          <br />

          <Modal size="lg" isOpen={modalColores} toggle={toggleColores}>
            <ModalHeader toggle={toggleColores}>
              <h4>Colores del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {colores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                  if (!arrayColores.includes(a._id)) {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              coloresSeleccionados(
                                e.currentTarget.checked,
                                a._id
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                  } else {
                    return <h5 className="subMenuTitulo">{a.name}</h5>;
                  }
                })}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalTallas} toggle={toggleTallas}>
            <ModalHeader toggle={toggleTallas}>
              <h4>Tallas del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {tallas
                .sort((a, b) => (a.idTalla > b.idTalla ? 1 : -1))
                .map((a, index) => {
                  if (!arrayTallas.includes(a._id)) {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              tallasSeleccionados(
                                e.currentTarget.checked,
                                a._id
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                  } else {
                    return <h5 className="subMenuTitulo">{a.name}</h5>;
                  }
                })}
            </ModalBody>
          </Modal>

          <Modal size="lg" isOpen={modalProcesos} toggle={toggleProcesos}>
            <ModalHeader toggle={toggleProcesos}>
              <h4>Procesos del Modelo {nombre}</h4>
            </ModalHeader>
            <ModalBody>
              {catalogoProcesos
                // .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a, index) => {
                  if (a._id != "6363fb596cdd150aab0461cd") {
                    return (
                      <table>
                        <td>
                          <Input
                            type="checkbox"
                            key={index}
                            onChange={(e) => {
                              procesosSeleccionados(
                                e.currentTarget.checked,
                                a._id
                              );
                            }}
                            className="subMenu"
                          />
                          <h5 className="subMenuTitulo">{a.name}</h5>
                        </td>
                      </table>
                    );
                  } else {
                    return <h5 className="subMenuTitulo">{a.name}</h5>;
                  }
                })}
            </ModalBody>
          </Modal>

          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>


        </div>
      ) : undefined}
    </>
  );
}

export default ArticulosCreateSolo;
